import { useState, useEffect } from 'react';
import { api } from '../api/client';

export function AdminPlansPage() {
  const [plans, setPlans] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [newPlan, setNewPlan] = useState({ id: '', name: '', token_credit: 1000000, price_usd: 0 });

  const load = () => {
    setLoading(true);
    api.adminGetPlans().then((res) => setPlans(res.plans || [])).finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, []);

  const handleSave = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!newPlan.id || !newPlan.name) return;
    try {
      await api.adminCreatePlan(newPlan);
      setNewPlan({ id: '', name: '', token_credit: 1000000, price_usd: 0 });
      load();
    } catch (e: any) {
      alert(e.message);
    }
  };

  const handleDelete = async (id: string) => {
    if (!confirm('Are you sure you want to delete this plan?')) return;
    try {
      await api.adminDeletePlan(id);
      load();
    } catch (e: any) {
      alert(e.message);
    }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
      <div className="page-header">
        <div>
          <h1 className="page-title">Billing Plans</h1>
          <p className="page-subtitle">Manage credit packages</p>
        </div>
      </div>

      <div className="card">
        <h2 style={{ fontSize: '14px', marginBottom: '16px' }}>Create / Update Plan</h2>
        <form onSubmit={handleSave} style={{ display: 'flex', gap: '12px', alignItems: 'flex-end', flexWrap: 'wrap' }}>
          <div>
            <label style={{ display: 'block', fontSize: '12px', marginBottom: '4px' }}>Plan ID</label>
            <input className="input" value={newPlan.id} onChange={e => setNewPlan({...newPlan, id: e.target.value})} placeholder="pack_1m" required />
          </div>
          <div>
            <label style={{ display: 'block', fontSize: '12px', marginBottom: '4px' }}>Name</label>
            <input className="input" value={newPlan.name} onChange={e => setNewPlan({...newPlan, name: e.target.value})} placeholder="1M Tokens" required />
          </div>
          <div>
            <label style={{ display: 'block', fontSize: '12px', marginBottom: '4px' }}>Token Credit</label>
            <input type="number" className="input" value={newPlan.token_credit} onChange={e => setNewPlan({...newPlan, token_credit: Number(e.target.value)})} required />
          </div>
          <div>
            <label style={{ display: 'block', fontSize: '12px', marginBottom: '4px' }}>Price (USD)</label>
            <input type="number" step="0.01" className="input" value={newPlan.price_usd} onChange={e => setNewPlan({...newPlan, price_usd: Number(e.target.value)})} required />
          </div>
          <button className="btn btn--primary">Save Plan</button>
        </form>
      </div>

      <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
          <thead>
            <tr style={{ background: 'var(--bg-elevated)', borderBottom: '1px solid var(--border-color)', textAlign: 'left' }}>
              <th style={{ padding: '12px 16px', fontWeight: 600 }}>ID</th>
              <th style={{ padding: '12px 16px', fontWeight: 600 }}>Name</th>
              <th style={{ padding: '12px 16px', fontWeight: 600 }}>Credit</th>
              <th style={{ padding: '12px 16px', fontWeight: 600 }}>Price</th>
              <th style={{ padding: '12px 16px', fontWeight: 600 }}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {loading ? <tr><td colSpan={4} style={{ padding: '16px', textAlign: 'center' }}>Loading...</td></tr> :
              plans.map(p => (
                <tr key={p.id} style={{ borderBottom: '1px solid var(--border-color)' }}>
                  <td style={{ padding: '12px 16px', fontFamily: 'monospace' }}>{p.id}</td>
                  <td style={{ padding: '12px 16px', fontWeight: 500 }}>{p.name}</td>
                  <td style={{ padding: '12px 16px' }}>{Number(p.token_credit).toLocaleString()}</td>
                  <td style={{ padding: '12px 16px' }}>${Number(p.price_usd).toFixed(2)}</td>
                  <td style={{ padding: '12px 16px', display: 'flex', gap: '8px' }}>
                    <button className="btn btn--secondary btn--sm" onClick={() => setNewPlan(p)}>Edit</button>
                    <button className="btn btn--secondary btn--sm" style={{ color: '#ef4444', borderColor: '#ef4444' }} onClick={() => handleDelete(p.id)}>Delete</button>
                  </td>
                </tr>
              ))
            }
          </tbody>
        </table>
      </div>
    </div>
  );
}
